import { render, staticRenderFns } from "./SensoresTiempoReal.vue?vue&type=template&id=514c72a1&scoped=true&"
import script from "./SensoresTiempoReal.vue?vue&type=script&lang=js&"
export * from "./SensoresTiempoReal.vue?vue&type=script&lang=js&"
import style0 from "./SensoresTiempoReal.vue?vue&type=style&index=0&id=514c72a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514c72a1",
  null
  
)

export default component.exports